import { BrandCaptionLowerThirdEntityRaw } from "@common/domain";
import { createEntityAdapter, EntityAdapter, EntityState } from "@ngrx/entity";
import { Action, createReducer, on } from "@ngrx/store";
import { RoomBrandCaptionLowerThirdActions } from "../actions";
import { RoomBrandCaptionLowerThirdEvents } from "../events";

export const ROOM_BRAND_CAPTION_LOWER_THIRD_FEATURE_KEY =
  "roomBrandCaptionLowerThird";

export interface RoomBrandCaptionLowerThirdState
  extends EntityState<Record<string, never>> {
  isLoading: boolean;
  brandCaptionLowerThird: null | BrandCaptionLowerThirdEntityRaw;
}

export const roomBrandCaptionLowerThirdAdapter: EntityAdapter<
  Record<string, never>
> = createEntityAdapter();

const initialState: RoomBrandCaptionLowerThirdState =
  roomBrandCaptionLowerThirdAdapter.getInitialState({
    isLoading: false,
    brandCaptionLowerThird: null
  });

const reducer = createReducer(
  initialState,
  on(
    RoomBrandCaptionLowerThirdActions.roomBrandCaptionLowerThirdCreate,
    (state) => ({
      ...state,
      isLoading: true
    })
  ),
  on(
    RoomBrandCaptionLowerThirdActions.roomBrandCaptionLowerThirdCreateSuccess,
    (state) => ({
      ...state,
      isLoading: false
    })
  ),
  on(
    RoomBrandCaptionLowerThirdActions.roomBrandCaptionLowerThirdCreateFailure,
    (state) => ({
      ...state,
      isLoading: false
    })
  ),
  on(
    RoomBrandCaptionLowerThirdActions.roomBrandCaptionLowerThirdDelete,
    (state) => ({
      ...state,
      isLoading: true
    })
  ),
  on(
    RoomBrandCaptionLowerThirdActions.roomBrandCaptionLowerThirdDeleteSuccess,
    (state) => ({
      ...state,
      isLoading: false
    })
  ),
  on(
    RoomBrandCaptionLowerThirdActions.roomBrandCaptionLowerThirdDeleteFailure,
    (state) => ({
      ...state,
      isLoading: false
    })
  ),
  on(
    RoomBrandCaptionLowerThirdActions.roomBrandCaptionLowerThirdUse,
    (state) => ({
      ...state,
      isLoading: true
    })
  ),
  on(
    RoomBrandCaptionLowerThirdActions.roomBrandCaptionLowerThirdUseSuccess,
    (state) => ({
      ...state,
      isLoading: false
    })
  ),
  on(
    RoomBrandCaptionLowerThirdActions.roomBrandCaptionLowerThirdUseFailure,
    (state) => ({
      ...state,
      isLoading: false
    })
  ),
  on(
    RoomBrandCaptionLowerThirdActions.roomBrandCaptionLowerThirdUnUse,
    (state) => ({
      ...state,
      isLoading: true
    })
  ),
  on(
    RoomBrandCaptionLowerThirdActions.roomBrandCaptionLowerThirdUnUseSuccess,
    (state) => ({
      ...state,
      isLoading: false
    })
  ),
  on(
    RoomBrandCaptionLowerThirdActions.roomBrandCaptionLowerThirdUnUseFailure,
    (state) => ({
      ...state,
      isLoading: false
    })
  ),
  on(
    RoomBrandCaptionLowerThirdActions.roomBrandCaptionLowerThirdUpdate,
    (state) => ({
      ...state,
      isLoading: true
    })
  ),
  on(
    RoomBrandCaptionLowerThirdActions.roomBrandCaptionLowerThirdUpdateSuccess,
    (state) => ({
      ...state,
      isLoading: false
    })
  ),
  on(
    RoomBrandCaptionLowerThirdActions.roomBrandCaptionLowerThirdUpdateFailure,
    (state) => ({
      ...state,
      isLoading: false
    })
  ),
  on(
    RoomBrandCaptionLowerThirdActions.roomBrandCaptionLowerThirdUseFailure,
    (state) => ({
      ...state,
      isLoading: false
    })
  ),
  on(
    RoomBrandCaptionLowerThirdEvents.roomBrandCaptionLowerThirdDeleteEvent,
    (state) => ({
      ...state,
      brandCaptionLowerThird: null
    })
  ),
  on(
    RoomBrandCaptionLowerThirdEvents.roomBrandCaptionLowerThirdSetEvent,
    (state, { roomBrandCaptionLowerThirdSetEventVO }) => ({
      ...state,
      brandCaptionLowerThird:
        roomBrandCaptionLowerThirdSetEventVO.value.caption.toJSON()
    })
  )
);

export function roomBrandCaptionLowerThirdReducer(
  state: RoomBrandCaptionLowerThirdState | undefined,
  action: Action
) {
  return reducer(state, action);
}
